export const NO_DOCUMENTS_FOUND_INTERNAL =
  'No Submission documents available yet.';
export const NO_DOCUMENTS_FOUND_EXTERNAL =
  'No Submission documents are available for your account.';
